import { useQuery } from "@tanstack/react-query"
import { getPlanVsActualReport } from "./PlanVsActualReport_Repo"

export const UsePlanVsActualReport=({param={},enable}:{param:any,enable:boolean})=>{
    return useQuery({
        queryKey:['PLAN_VS_ACTUAL_REPORT',param],
        queryFn:()=>getPlanVsActualReport(param),
        enabled:enable,
        retry:false,
    })
}
